import React, { FC, useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useCouriersState } from '../../context/couriers';
import OrderList from '../OrderList';
import CourierDetail from '../CourierDetail';
import useStyles from './styles';
import CourierList from '../CourierList';
import OrderDetail from '../OrderDetail';
import NoDataInformation from '../NoDataInformation';
import {useOrdersState } from '../../context/orders';
import {
  DeliveryMenuNavigationItem,
  useDeliveryNavigationActions,
  useDeliveryNavigationState,
} from '../../context/delivery-navigation';
import Button from '@src/shared/components/Button';
import { useHistory } from 'react-router-dom';
import { trackDeliveryDashboardNavigationTabButton, trackDeliveryDashboardOnLoadNavigationView } from '../../tracking/delivery-dashboard';
import { useKeycloakUserState } from '@src/shared/context/keycloak-user';
import JetSegmentedControl from '@src/shared/components/JetSegmentedControl';
interface InfoBarProps {
  isMobileViewActive?: boolean;
  infoSection?: DeliveryMenuNavigationItem;
}

const InfoBar: FC<InfoBarProps> = ({ isMobileViewActive }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  const { setActiveMenu, flushMenu } = useDeliveryNavigationActions();
  const { selectedNavigationItem } = useDeliveryNavigationState();
  const [ selectedMenu, setSelectedMenu ] = useState(selectedNavigationItem)
  const { couriersById, selectedCourierId } = useCouriersState();
  const { ordersById, selectedOrderId } = useOrdersState();
  const { restaurant } = useKeycloakUserState();

  const history = useHistory();
  const navigateTo = (route: string) => history.push(`/${route}`);

  const segmentedControllerContainerRef = useRef<HTMLDivElement>(null);
  const infoBarRef = useRef<HTMLDivElement | null>(null);

/*   useEffect(() => {
    if(activeOrderFilter) {
      console.log('Im here')
      setFilteredOrders(Object.values(ordersById).filter(res => res.status === activeOrderFilter) as any);
    }
    return (() => setFilteredOrders(ordersById))
  },[activeOrderFilter]) */

  useEffect(() => {
    if (!isMobileViewActive && selectedNavigationItem === 'MAP') {
      flushMenu();
      setSelectedMenu(DeliveryMenuNavigationItem.CourierApp)
    }
  }, [isMobileViewActive]);

  useEffect(()=>{
    setSelectedMenu(selectedNavigationItem)
  },[selectedNavigationItem])
  const handleAnalytics = (value : any) => {
    if (value === DeliveryMenuNavigationItem.CourierApp) {
      trackDeliveryDashboardNavigationTabButton(
        restaurant?.language,
        restaurant?.country,
        'active couriers click'
      );
      trackDeliveryDashboardOnLoadNavigationView(
        {
          component_name:'active couriers',
          language: restaurant?.language || '',
          list_countsTotals: '',
          list_filter: ''         
        }
      )
    } else if (value === DeliveryMenuNavigationItem.Orders) {
      trackDeliveryDashboardNavigationTabButton(
        restaurant?.language,
        restaurant?.country,
        'orders today click'
      );
    }
  }
  const handleSegmentedControlOnSelected = (value : any) => {
    setActiveMenu(value); 
    handleAnalytics(value)
    setSelectedMenu(value)
    if (infoBarRef.current) {
      infoBarRef.current.scroll({ top:0 })
    }
  }

  const ordersTabTitle = `${t('deliveries.tab_orders')} (${(Object.keys(ordersById).length)})`
  return (
    <div className={`${classes.infoBar} ${isMobileViewActive ? 'mobile' : ''}`} ref={infoBarRef}>
      {!selectedCourierId && !selectedOrderId ? (
        <>
          {!isMobileViewActive ? (
            <div className={`${classes.infoBarHeader}`}>
              <div className={`${classes.segmentedControlContainer} fixed`} ref={segmentedControllerContainerRef}>
                <JetSegmentedControl 
                titles={[t('deliveries.tab_couriers'), ordersTabTitle]} 
                values={[DeliveryMenuNavigationItem.CourierApp, DeliveryMenuNavigationItem.Orders]}
                onSelected={(value)=> {handleSegmentedControlOnSelected(value)}}
                model={selectedMenu}/>
              </div>
            </div>
          ) : null}
          {selectedNavigationItem === DeliveryMenuNavigationItem.CourierApp ? (
            <>
              {Object.keys(couriersById).length > 0  ? (
                <CourierList {...couriersById} />
              ) : (
                <NoDataInformation
                  title={t(`emptyStage.stage_no_couriers`)}
                  subtitle={t(`emptyStage.stage_title_courier`)}
                >
                  <Button
                    className={classes.inviteButton}
                    fullWidth
                    color="primary"
                    variant="contained"
                    onClick={() => navigateTo('couriers')}
                  >
                    {t(`emptyStage.stage_invite_couriers`)}
                  </Button>
                </NoDataInformation>
              )}
            </>
          ) : null}

          {selectedNavigationItem === DeliveryMenuNavigationItem.Orders ? (
            <>
              
              {Object.keys(ordersById).length > 0 ? (
                <OrderList {...ordersById} />
              ) : (
                <NoDataInformation title={t(`emptyStage.stage_no_orders`)} />
              )}
            </>
          ) : null}
        </>
      ) : (
        <>
          {selectedCourierId && !isMobileViewActive ? (
            <CourierDetail {...couriersById[selectedCourierId]} />
          ) : null}
          {selectedOrderId && !isMobileViewActive ? (
            <OrderDetail {...ordersById[selectedOrderId]} />
          ) : null}
        </>
      )}
    </div>
  );
};

export default InfoBar;
